export const Colors = {
    orange: '#C4940C',
    secondary_orange: '#FF9900',
    primary_blue: '#043B74',
    secondary_blue: '#2596BE',
    light_gray: '#EDEDED',
    darkoverlay: '#1E1E1E',
};
